import { ChatCSS } from '@/types/layouts'

const chatCSS: ChatCSS = {
  general: {
    font: 'Helvetica',
    fontsize: 6
  },
  user1: { 
    bg: '#2a92e7',
    text: '#ffffff'
  },
  user2: {
    bg: '#3d3e44',
    text: '#ffffff'
  },
  user3: {
    bg: '#070707',
    text: '#ffffff'
  },
  user4: {
    bg: '#40434E',
    text: '#ffffff'
  }
}

export default chatCSS
